import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Gengduo = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4c2__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb4c2__a)">
            <path
              fillRule="evenodd"
              d="M9.036 27h-.072A2.939 2.939 0 0 0 6 29.964v.072A2.939 2.939 0 0 0 8.964 33h.072A2.939 2.939 0 0 0 12 30.036v-.072A2.939 2.939 0 0 0 9.036 27m0 15h-.072A2.939 2.939 0 0 0 6 44.964v.072A2.939 2.939 0 0 0 8.964 48h.072A2.939 2.939 0 0 0 12 45.036v-.072A2.939 2.939 0 0 0 9.036 42m0 15h-.072A2.939 2.939 0 0 0 6 59.964v.072A2.939 2.939 0 0 0 8.964 63h.072A2.939 2.939 0 0 0 12 60.036v-.072A2.939 2.939 0 0 0 9.036 57"
              transform="rotate(-90 6 27)"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
